import React, { FC } from 'react';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { TOverviewTextProps } from '../../types/overviewText.types';
import { OverviewTextModel } from '../../models/overviewText.model';
import CTAButton, { ctaEnums } from '../../../@shared/ctaButton';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import Icon from '../../../@shared/icon';
import { targetLinkdsk } from '../../../../utils/targetDskLink';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import { googleClickCtaEvent } from '../../../../utils/analytics';
import useGetBuildAndPriceLink from '../../../../hooks/useGetBuildAndPriceLink';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';

const OverviewText: FC<TOverviewTextProps> = (props) => {
  const model = new OverviewTextModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);
  const buildAndPriceUrl = useGetBuildAndPriceLink('series');

  return (
    <div className="series-overview-text">
      <Text field={model.eyebrow} tag="p" className="series-overview-text__eyebrow" editable={false} />
      <Text field={model.title} tag="h2" className="series-overview-text__title" editable={false} />
      <RichText field={model.description} tag="div" className="series-overview-text__description rich-text" editable={false} />

      {((model?.primaryLink?.label && model?.primaryLink?.url) || (model?.secondaryLink?.label && model?.secondaryLink?.url) || (model?.enableBuildPriceCTA && buildAndPriceUrl)) && (
        <>
          <div className="series-overview-text__link-wrapper">
            {model?.enableBuildPriceCTA && buildAndPriceUrl && (
              <span className={'series-overview-text__link series-overview-text__link--primary'}>
                <CTAButton type={ctaEnums.primaryRed}>
                  <RoutableNotEditableLink
                    href={appendRootToInternalLink(buildAndPriceUrl)}
                  >
                    <DictionaryTerm keyword={'cnhi-build-price'} />
                  </RoutableNotEditableLink>
                </CTAButton>
              </span>
            )}
            {model?.primaryLink?.label && model?.primaryLink?.url && (
              <span className={'series-overview-text__link series-overview-text__link--primary'}>
                <CTAButton type={ctaEnums.primaryRed}>
                  <RoutableNotEditableLink
                    href={model.primaryLinkUrl}
                    target={targetLinkdsk({ value: { href: model?.primaryLink?.url, target: model?.primaryLink?.target } }, isDesktop)}
                    onClick={() => googleClickCtaEvent('Button', model?.primaryLink?.label, model.title?.value)}
                  >
                    {model.primaryLink.label}
                  </RoutableNotEditableLink>
                </CTAButton>
              </span>
            )}
            {model?.secondaryLink?.label && model?.secondaryLink?.url && (
              <span className={'series-overview-text__link series-overview-text__link--secondary'}>
                <RoutableNotEditableLink
                  href={model.secondaryLinkUrl}
                  target={targetLinkdsk({ value: { href: model?.secondaryLink?.url, target: model?.secondaryLink?.target } }, isDesktop)}
                  onClick={() => googleClickCtaEvent('Button', model?.secondaryLink?.label, model.title?.value)}
                >
                  {model.secondaryLink.label}
                </RoutableNotEditableLink>
                <Icon iconName="arrow-simple-right" extraClassName="series-overview-text__icon" size={24} color="primary" />
              </span>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default OverviewText;
